import styled from 'styled-components'

export const ContainerAutoComplete = styled.div`
  .MuiOutlinedInput-root {
    border-color: transparent !important;
    border: none !important;
    height: 40px;
    border-radius: 24px !important;
    color: ${({ theme }) => theme.cor9}!important;
    background-color: ${({ theme }) => theme.cor27}!important;

    & fieldset {
      border-color: transparent !important;
      border: none !important;
    }

    div.MuiInputBase-root {
      background-color: ${({ theme }) => theme.cor27}!important;
    }
    & svg {
      fill: ${({ theme, isQuantidade }) =>
        isQuantidade
          ? theme.designSystem.background.danger
          : theme.designSystem.background.primary} !important;
    }

    & label {
      color: ${({ theme }) => theme.cor9}!important;
    }
    & input {
      color: ${({ theme }) => theme.cor9}!important;
    }
  }

  .MuiAutocomplete-paper {
    color: ${({ theme }) => theme.cor9}!important;
    background-color: ${({ theme }) => theme.cor27}!important;
  }

  .MuiAutocomplete-option {
    &:hover {
      background-color: ${({ theme }) => theme.cor57} !important;
    }
  }

  .MuiAutocomplete-option[aria-selected='true'] {
    background-color: ${({ theme }) => theme.cor57} !important;
    color: ${({ theme }) => theme.cor9}!important;
  }

  .MuiAutocomplete-noOptions,
  .MuiAutocomplete-loading {
    color: ${({ theme }) => theme.cor9}!important;
  }
`

export const Erro = styled.span`
  font-family: RobotoRegular;
  font-size: 14px;
  line-height: 1.5em;
  color: ${({ theme }) => theme.cor12}!important;
  margin: 0;
`
